import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Translate from "../../../Components/Multilanguage/Translate";
import * as service from "./service";
import { authenticate2 } from "../../../network/service";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";

const ParentalSettings = () => {
  const dispatch = useDispatch();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const accessToken = useSelector((state) => state.accessToken?.value);
  const user = useSelector((state) => state?.user?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);

  const userEmail = useMemo(
    () => userDetails?.user_email || user?.user_email || user?.email || localStorage.getItem("user_email") || "",
    [userDetails, user]
  );

  const appInfo = {
    accessToken,
    projectDetails: projectInfo,
  };

  useEffect(() => {
    if (!userEmail && (accessToken || localStorage.getItem("userId"))) {
      authenticate2(appInfo).then((res) => {
        if (res?.data?.user_email) {
          localStorage.setItem("user_email", res.data.user_email);
          dispatch(getUserDetails({ userDetails: res.data }));
        }
      }).catch(() => {});
    }
  }, [userEmail, accessToken]);

  const requestResetLink = async () => {
    try {
      if (!userEmail) {
        toast.error("Email not found. Please login again.", {
          position: "top-center",
        });
        return;
      }

      setIsSubmitting(true);
      const response = await service.requestParentalPinReset(appInfo, userEmail);

      if (response?.status === 200 || response?.success === true) {
        toast.success(response?.data?.message || response?.message, {
          position: "top-center",
        });
      } else {
        toast.error(response?.data?.message || response?.message, {
          position: "top-center",
        });
      }
    } catch (err) {
      toast.error(err?.response?.data?.message, {
        position: "top-center",
      });
    } finally {
      setIsSubmitting(false);
      setShowConfirmModal(false);
    }
  };

  return (
    <div
      className="resetPassword parentalSettingsPage"
      role="main"
      aria-label="Parental Settings Page"
    >
      <ToastContainer />
      <div className="wrapper">
        <h1 className="heading">
          <Translate textKey={"parental_settings"} />
        </h1>
        <div className="contents">
          <div className="formSection parentActionCard">
            <button
              type="button"
              className="parentalPrimaryButton"
              aria-label="Reset Parental PIN"
              onClick={() => setShowConfirmModal(true)}
            >
              <Translate textKey={"reset_parental_pin"} />
            </button>
          </div>
        </div>

        {showConfirmModal && (
          <div className="parentalConfirmOverlay">
            <div className="parentalConfirmModal" role="dialog" aria-modal="true">
              <h3>
                <Translate textKey={"reset_parental_pin"} />
              </h3>
              <p>
                <Translate textKey={"parental_pin_reset_confirmation"} />
              </p>
              <div className="parentalConfirmActions">
                <div
                  className="parentalConfirmButtonContainer yes"
                  onClick={isSubmitting ? undefined : requestResetLink}
                  role="button"
                  tabIndex={isSubmitting ? -1 : 0}
                  onKeyDown={(e) => {
                    if (!isSubmitting && (e.key === "Enter" || e.key === " ")) {
                      requestResetLink();
                    }
                  }}
                >
                  <div className="background"></div>
                  <button type="button" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <Translate textKey={"submitting"} />
                    ) : (
                      <Translate textKey={"yes"} />
                    )}
                  </button>
                </div>

                <div
                  className="parentalConfirmButtonContainer no"
                  onClick={isSubmitting ? undefined : () => setShowConfirmModal(false)}
                  role="button"
                  tabIndex={isSubmitting ? -1 : 0}
                  onKeyDown={(e) => {
                    if (!isSubmitting && (e.key === "Enter" || e.key === " ")) {
                      setShowConfirmModal(false);
                    }
                  }}
                >
                  <div className="background"></div>
                  <button type="button" disabled={isSubmitting}>
                    <Translate textKey={"no"} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentalSettings;
